import { useEffect } from "react";
import { useUniModalPortableContainer } from "../hooks/useUniModalPortableContainer";
// import JSDisplayObject from "./JSDisplayObject";
import { js_utils } from "../utils/frfr-js-utils";
import Btn from "./Btn";
import JSDisplayValue from "./JSDisplayValue";
import UniModalPresentationalBottomSheetKoglovo from "./UniModalPresentationalBottomSheetKoglovo";
import TableGenerator from "./TableGenerator";
import UniLimiter from "./UniLimiter";
import UniModalPortableContainer from "./UniModalPortableContainer";
import UniPaper from "./UniPaper";
import UniSpinnerClassic from "./UniSpinnerClassic";
import UniBtn from "./UniBtn";
import RapidoziDisplayValue from "./RapidoziDisplayValue";
import UniViewMultimodeTableGenerator from "./UniViewMultimodeTableGenerator";


const ViewGeneratorSimpleV4 = (props) => {
  const {
    route_freshness,
    rapidoziViewDefinition,
    viewDefinition,
    viewArr,
    fetching,
    jsxSpinner, // TODO
  } = props;
  const {
    cbSubmitEntityCreate,
  } = rapidoziViewDefinition;
  const {
    cbEntityKeyExtractor,
    cbEntityColumnValExtractor,
    cbRefresh,
    cbEntityActionsJsx,
    options,

    //TODO NOVO
    cbEntityColumnValFixForDisplay,
    cbEntityColumnTitleTranslator,

    cbModalCreate,
    cbSubmitCreate,
    cbSubmitUpdate,
  } = viewDefinition;

  let jsxSpinnerCustom = null;
  jsxSpinnerCustom = (
    <UniSpinnerClassic />
  );
  if (jsxSpinner) {
    jsxSpinnerCustom = jsxSpinner
  }
;
  let table_additional_column_keys = [];
  if (Array.isArray(viewDefinition.table_additional_column_keys)) {
    table_additional_column_keys = viewDefinition.table_additional_column_keys;
  }

  let is_show_entity = true;
  if (options?.entity_col_disabled === true) {
    is_show_entity = false;
  }
  let showSelectable = false;
  if (options?.showSelectable === true) {
    showSelectable = true;
  }

  // -----
  const {
    setUniModalPortableContent,
    setUniModalPortableClose,
    uniModalPortableContainerPack,
  } = useUniModalPortableContainer();
  // -----

  /*
  useEffect(() => {
    cbRefresh();
  }, []);
  */
  //
  useEffect(() => { // REFRESH BY ROUTE (or refresh once on mount)
    cbRefresh();
  }, [route_freshness]);

  console.log('viewArr', viewArr);

  let arr = [];
  let jsxZero = null;
  let jsxError = null;
  if (fetching === true) {

  } else {
    if (Array.isArray(viewArr)) {
      console.log('viewArr', viewArr);
      arr = viewArr;
      if (arr.legth === 0) {
        jsxZero = (
          <div className="view-generator-simple__zero-items">No items to show</div>
        );
      }
    } else {
      // ERROR
      jsxError = (
        <div className="jsunicompo-display-velue-error-msg"><span>ERROR: viewArr is not an Array!</span></div>
      );
    }
  }


  //
  let _tableBlueprint_columns_entity = [];
  if (is_show_entity) {
    _tableBlueprint_columns_entity = [
      {
        key: 'KEY',
        title: 'KEY',
        sortable: true,
        filterable: true,
        searchable: false,
        extraClassTh: 'uu-text-nowrap',
        tdCb: (row, k, col_index, row_index) => {
          const entity = row;
          let id = null;
          if (typeof cbEntityKeyExtractor === 'function') {
            id = cbEntityKeyExtractor(entity);
          }
          return (<JSDisplayValue val={id} />);
        },
        cellValueExtractor: (row, col_key, col_index, row_index) => {
          const entity = row;
          let id = null;
          if (typeof cbEntityKeyExtractor === 'function') {
            id = cbEntityKeyExtractor(entity);
          }
          // return (<JSDisplayValue val={id} />);
          return id;
        },
        minWidth: 64,
      },
      {
        key: 'ENTITY',
        title: 'ENTITY',
        sortable: false,
        filterable: false,
        searchable: false,
        extraClassTh: 'uu-text-nowrap',
        tdCb: (row, row_index, col_index) => { return (<JSDisplayValue val={row} initialCollapsed={true} />); },
        resizable: true,
        minWidth: 144,
      },
    ];
  }
  let _tableBlueprint_columns_4 = table_additional_column_keys;
  _tableBlueprint_columns_4 = table_additional_column_keys.map((item) => {
    if (typeof item === 'string') {
      return {
        key: item,
        title: item,
        resizable: true,
        minWidth: 128,
      };
    } else {
      return {
        minWidth: 128,
        resizable: true,
        ...item,
      };
    }
  });
  /*
  if (typeof view_to_table_mapCb === 'function') {
    _tableBlueprint_columns_4 = table_additional_column_keys.map(view_to_table_mapCb);
  }
  */
  if (typeof cbEntityColumnValExtractor === 'function') {
    // val = cbEntityColumnValExtractor(entity, key);
    _tableBlueprint_columns_4 = table_additional_column_keys.map((column_key) => {
      const col_blu = {
        key: column_key,
        title: column_key,
        sortable: true,
        filterable: true,
        searchable: false,
        tdCb: (row, k, col_index, row_index) => {
          const val = cbEntityColumnValExtractor(row, k);
          if (typeof cbEntityColumnValFixForDisplay === 'function') { // TODO NOVO
            const val_to_display = cbEntityColumnValFixForDisplay(k, val);
            return (<JSDisplayValue val={val_to_display} />);
          }
          return (<JSDisplayValue val={val} />);
          //return val;
        },
        resizable: true,
        minWidth: 128,
      };
      if (typeof cbEntityColumnTitleTranslator === 'function') { // TODO NOVO
        col_blu.title = cbEntityColumnTitleTranslator(column_key);
      }
      return col_blu;
    });
  }
  //
  const tableBlueprint_columns = [
    {
      key: 'No',
      title: '#',
      sortable: false,
      filterable: false,
      searchable: false,
      tdCb: (row, k, col_index, row_index) => { return (row_index + 1); },
      minWidth: 32,
    },
    {
      key: 'Actions',
      title: 'Actions',
      sortable: false,
      filterable: false,
      searchable: false,
      extraClass: 'uu-min-w-max-content',
      extraClassTh: 'uu-text-wrap',
      tdCb: (row, k, col_index, row_index) => {
        // return 'cbEntityActionsJsx';
        const entity = row;
        return typeof cbEntityActionsJsx === 'function' ? (cbEntityActionsJsx(entity)) : (null)
      },
      minWidth: 320,
      minWidth: 128,
      minWidth: 160,
      // resizable: true,
    },
    ..._tableBlueprint_columns_entity,
    ..._tableBlueprint_columns_4,
  ];

  // convert data to shallow (keyval pairs) Array of Objects for sorting and filtering table
  console.log('arr', arr);
  let arrFixed = arr;
  if (typeof cbEntityColumnValExtractor === 'function') {
    console.log('arr', arr);
    arrFixed = arr.map((entity, row_index) => {
      const fixed_entity = {
        ...entity,
      };
      table_additional_column_keys.forEach((key) => {
        const val = cbEntityColumnValExtractor(entity, key);
        fixed_entity[key] = val;
      });
      return fixed_entity;
    });
  }
  console.log('arrFixed', arrFixed);


  /*
        <UniLimiter maximize>
          <UniPaper overflowHidden extraClass="uu-shadow-alien-mui-elevation1">
  */
  return (
    <>
      <div className="view-generator-simple">
        <UniLimiter maximize fullWidth>
          <UniPaper overflowHidden extraClass="uu-shadow-alien-mui-elevation1">
            <UniViewMultimodeTableGenerator
              viewMultimodeBlueprint={{
                freshness: null,
                general: {
                  pagination_enabled: true,
                  pagination_rowsPerPageInitial: 10,
                  responsiveTable: true,
                  // widgetExtraClass: 'frfr-table-generator__pack--alien-mui-basic-table-widget',
                  // widgetExtraClass: "frfr-table-generator__pack--pagination-left frfr-table-generator__pack--responsive",
                  widgetExtraClass: "frfr-table-generator__pack--pagination-left",
                  // tableContainerExtraClass: 'uu-anytable__table-container--responsive',
                },
                table: {
                  showFilterRow: true,
                  // showSelectable: false,
                  showSelectable: showSelectable,
                  showSelectableSingular: false,
                  resizable: true,
                  // extraClass: 'alien-mui-table__table uu-text-nowrap',
                  extraClass: 'frfr-table__table uu-text-nowrap frfr-table__table--alien-mui-basic-table',
                },
                defaultColumnBlueprint: {
                  sortable: true,
                  filterable: true,
                  searchable: false,
                  // tdCb: (row, col_key, col_index, row_index) => { return (<JSDisplayValue val={row?.[col_key]} />); },
                  tdCb: (row, col_key, col_index, row_index) => { return (<RapidoziDisplayValue val={row?.[col_key]} />); },
                  // tdCb: (row, col_key, col_index, row_index) => { return (<RapidoziDisplayValue val={"//assets.applabz.work/kliknamestaj/kliknamestaj-bg02.jpg"} />); },
                  // cellValueExtractor: (row, col_key, col_index, row_index) => { return row?.[col_key]; },
                },
                columns: tableBlueprint_columns,
                row: {
                  rowKeyExtractor: cbEntityKeyExtractor,
                },
              }}
              fetching={fetching}
              rowsData={arrFixed}
              jsxSpinnerCustom={jsxSpinnerCustom}
              widgetExtraClass={'frfr-table-generator__pack--alien-mui-basic-table-widget'}
              // tableContainerExtraClass={'uu-anytable__table-container--responsive'}
              tableExtraClass={''}
              cbOnSelectionChange={props.cbOnSelectionChange}
            />
          </UniPaper>
          <div className="uu-gap-standalone-1rem"></div>
          <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
            <UniBtn
              disabled={false}
              inline
              wide
              circle_EX
              i="fa fa-plus"
              title="CREATE"
              handleClick={() => {
                //
                cbModalCreate(cbSubmitCreate);
                /*
                setUniModalPortableContent({
                  options: {},
                  jsx: (<>nesto u modalu</>),
                });
                */
              }}
            />
            <UniBtn
              disabled={false}
              inline
              wide_EX
              outline
              circle_EX
              i="fa fa-refresh"
              title_EX="Refresh"
              handleClick={() => { cbRefresh?.(); }}
            />
          </div>
        </UniLimiter>

        <UniModalPortableContainer
          uniModalPortableContainerPack={uniModalPortableContainerPack}
          ComponentModal={UniModalPresentationalBottomSheetKoglovo}
          containerOptions={null}
        />
      </div>
    </>
  );
};

export default ViewGeneratorSimpleV4;